import { fontFace } from 'theme/mixins';

export default {
  import: fontFace('HelveticaNeueCyr'),
  fontStack: "Helvetica Neue, 'HelveticaNeueCyr', sans-serif",
};
